class VideoOverImage extends HTMLElement {
  connectedCallback() {
    const root = this.querySelector('[data-video-root]');
    if (!root) return;

    const video = root.querySelector('[data-video-element]') || root.querySelector('video');
    if (!video) return;

    const controlsHost = root.querySelector('[data-show-controls]');
    const wantControls = controlsHost && controlsHost.getAttribute('data-show-controls') === 'true';

    try { video.controls = false; } catch (_) {}

    const reveal = () => {
      root.classList.add('video-is-ready');
      if (wantControls) {
        try { video.setAttribute('controls', ''); } catch (_) {}
      }
    };

    if (video.readyState >= 2) {
      reveal();
    } else {
      const onReady = () => reveal();
      video.addEventListener('canplay', onReady, { once: true });
      video.addEventListener('loadeddata', onReady, { once: true });
    }
  }
}
if (!customElements.get('video-over-image')) {
  customElements.define('video-over-image', VideoOverImage);
}
